// src/portal-app/shell/kit/EmptyFieldsPrompt.js
//
// Collapses consecutive unset fields into ONE prompt.
//
// Employee Detail previously rendered Date of Birth, Address, Emergency Name,
// Relationship and Phone as five consecutive em-dash rows — five rows to say
// five things are missing, which made the screen look broken (spec §1 #4).
// This is one row: "Date of birth, address and emergency contact not set" [ADD]
import React from 'react';
import { GlassCard } from '../LiquidGlass';
import { useLanguage } from '../../../context/LanguageContext';
import { ensureKitCss } from './kitCss';
import { IconPlus } from './icons';

// "A, b and c" — first field keeps its capital, the rest are lowercased so the
// sentence reads naturally rather than as a list of headings.
function joinFields(fields, andWord) {
    const [first, ...rest] = fields;
    if (rest.length === 0) return first;
    const lowered = rest.map((f) => String(f).toLowerCase());
    if (lowered.length === 1) return `${first} ${andWord} ${lowered[0]}`;
    return `${first}, ${lowered.slice(0, -1).join(', ')} ${andWord} ${lowered[lowered.length - 1]}`;
}

export function EmptyFieldsPrompt({ fields, onAdd }) {
    ensureKitCss();
    const { t } = useLanguage();

    if (!Array.isArray(fields) || fields.length === 0) return null;

    const list = joinFields(fields, t('and', {}, 'and'));
    const sentence = `${list} ${t('not_set', {}, 'not set')}`;

    return (
        <GlassCard className="pk-empty" data-testid="empty-fields-prompt">
            <span className="pk-empty-icon" aria-hidden="true"><IconPlus /></span>
            <span className="pk-empty-text">{sentence}</span>
            {typeof onAdd === 'function' && (
                <button type="button" className="pk-empty-add" onClick={onAdd}>
                    {t('add', {}, 'Add')}
                </button>
            )}
        </GlassCard>
    );
}

export default EmptyFieldsPrompt;
